<template>
  <div class="favorite-container">
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h3>添加到我的最愛</h3>
        <p>確定要將 "{{ songName }}" 添加到我的最愛嗎？</p>
        <div class="button-group">
          <button @click="confirmAdd" class="btn-confirm">確定</button>
          <button @click="closeModal" class="btn-cancel">取消</button>
        </div>
        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useUserStore } from '../store/useUserStore';
import { usePlaylistStore } from '../store/usePlaylistStore';
import axiosInstance from '@/axios';
import { getCookie } from './csrf.js';

const userStore = useUserStore();
const playlistStore = usePlaylistStore();
const showModal = ref(false);
const songName = ref('');
const errorMessage = ref('');
const currentSongId = ref(null);

// 打開確認對話框
const openAddFavorite = async (songId, event) => {
  try {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!userStore.isLoggedIn) {
      alert('請先登入後再添加到我的最愛');
      return;
    }

    console.log('開始獲取歌曲信息，songId:', songId);
    const response = await axiosInstance.get(`/songs/${songId}/`);
    console.log('歌曲信息響應:', response.data);
    songName.value = response.data.songname;
    currentSongId.value = songId;
    showModal.value = true;
    errorMessage.value = '';
    console.log('模態框已打開，showModal:', showModal.value);
  } catch (error) {
    console.error('獲取歌曲信息失敗:', error);
    errorMessage.value = '獲取歌曲信息失敗';
    alert('獲取歌曲信息失敗');
  }
};

// 修改 addCurrentPlayingSong 方法
const addCurrentPlayingSong = async () => {
  try {
    if (!userStore.isLoggedIn) {
      alert('請先登入後再添加到我的最愛');
      return;
    }

    const currentSong = playlistStore.getCurrentPlayingSongInfo;
    if (!currentSong || !currentSong.id) {
      alert('目前沒有正在播放的歌曲');
      return;
    }

    console.log('開始獲取當前播放歌曲信息');
    const response = await axiosInstance.get(`/songs/${currentSong.id}/`);
    songName.value = response.data.songname;
    currentSongId.value = currentSong.id;
    showModal.value = true;
    errorMessage.value = '';
  } catch (error) {
    console.error('獲取歌曲信息失敗:', error);
    alert('獲取歌曲信息失敗');
  }
};

// 確認添加
const confirmAdd = async (event) => {
  try {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    console.log('開始確認添加流程');
    const customId = userStore.user?.customer_id;
    if (!customId) {
      errorMessage.value = '請先登入';
      alert('請先登入');
      return;
    }

    console.log('用戶 customId:', customId);
    const response = await axiosInstance.get(`/customer/${customId}/balancepoints/`);
    console.log('獲取用戶收藏列表響應:', response.data);
    const favoriteList = response.data.favoritesongsID || [];
    
    console.log('原始收藏列表:', favoriteList);
    console.log('要添加的歌曲 ID:', currentSongId.value);
    console.log('收藏列表類型:', typeof favoriteList, Array.isArray(favoriteList));

    if (favoriteList.length >= 50) {
      errorMessage.value = '我的最愛已滿，請至編輯頁面整理';
      alert('我的最愛已滿，請至編輯頁面整理');
      return;
    }

    if (favoriteList.includes(currentSongId.value)) {
      errorMessage.value = '此歌曲已在我的最愛中';
      alert('此歌曲已在我的最愛中');
      closeModal();
      return;
    }

    // 確保 favoriteList 是數組
    const updatedFavoriteList = Array.isArray(favoriteList) ? [...favoriteList] : [];
    updatedFavoriteList.push(currentSongId.value);
    
    console.log('更新前的收藏列表:', favoriteList);
    console.log('更新後的收藏列表:', updatedFavoriteList);
    console.log('準備更新收藏列表，customId:', customId);
    const updateResponse = await axiosInstance.post(
      `/customer/${customId}/updatebalance/`,
      {
        favoritesongsID: updatedFavoriteList
      },
      {
        headers: {
          'X-CSRFToken': getCookie('csrftoken')
        }
      }
    );
    console.log('更新收藏列表響應:', updateResponse.data);

    showModal.value = false;
    errorMessage.value = '';
  } catch (error) {
    console.error('添加收藏失敗:', error);
    errorMessage.value = '添加收藏失敗，請稍後重試';
    alert('添加收藏失敗，請稍後重試');
    showModal.value = false;
  }
};

// 關閉對話框
const closeModal = (event) => {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  showModal.value = false;
  errorMessage.value = '';
};

// 導出方法供其他組件使用
defineExpose({
  openAddFavorite,
  addCurrentPlayingSong
});
</script>

<style scoped>
.favorite-container {
  /* 容器樣式 */
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.btn-confirm, .btn-cancel {
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-confirm {
  background-color: #4CAF50;
  color: white;
}

.btn-cancel {
  background-color: #f44336;
  color: white;
}

.error-message {
  color: red;
  margin-top: 10px;
  text-align: center;
}
</style> 